export default __webpack_public_path__ + "static/media/girls-top.71b3e33b.png";